import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const impactAnalysisPlugin = createPlugin({
  id: 'impact-analysis',
  routes: {
    root: rootRouteRef,
  },
});

export const ImpactAnalysisPage = impactAnalysisPlugin.provide(
  createRoutableExtension({
    name: 'ImpactAnalysisPage',
    mountPoint: rootRouteRef,
    component: () =>
      import('./components/ImpactAnalysisRoute').then(
        m => m.ImpactAnalysisRoute,
      ),
  }),
);
